module.exports = __webpack_public_path__ + "static/media/Food.9f85d985.svg";